// BetaAccessContext
// Global context for managing beta access modal across the application

import React, { createContext, useContext, useState, useCallback } from 'react';
import { BetaAccessModal } from '../components/BetaAccessModal';

const BetaAccessContext = createContext();

export function BetaAccessProvider({ children }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const showBetaAccessModal = useCallback(() => {
    setIsModalOpen(true);
  }, []);

  const hideBetaAccessModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const value = {
    showBetaAccessModal,
    hideBetaAccessModal,
  };

  return (
    <BetaAccessContext.Provider value={value}>
      {children}
      <BetaAccessModal
        isOpen={isModalOpen}
        onClose={hideBetaAccessModal}
      />
    </BetaAccessContext.Provider>
  );
}

export function useBetaAccess() {
  const context = useContext(BetaAccessContext);
  if (!context) {
    throw new Error('useBetaAccess must be used within a BetaAccessProvider');
  }
  return context;
}